import { createContext } from "react";
import type { CCProcessorConfiguration } from "components/online_ordering/checkout/payment/CCProcessorConfigurationMap";

export const CCProcessorConfigurationContext =
  createContext<CCProcessorConfiguration | null>(null);
